/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import Table from 'react-bootstrap/Table';
import './Analizador.css';

function Analizador(props) {
    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);
    const {code} = props;

    var [EM, setEM] = useState([]);
    var [htmlEM, setHtmlEM] = useState(<></>);
    const variablesAPedir="description,timeStamp,p,s,pF,q,wp_dmd,wp_sup,wq_ind,wq_cap,ws,iL1,iL2,iL3,uL1L2,uL2L3,uL3L1,pL1,pL2,pL3,qA,qB,qC,sA,sB,sC,pFa,pFb,pFc,thdsVaVab,thdsVbVbc,thdsVcVca,thdsIa,thdsIb,thdsIc,f";

    let number = 0;
        useEffect(() => {
        fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/energyMeter?idSolarFarm="+idParque+"&variables="+variablesAPedir, { method: 'GET', credentials: 'include' })
        .then( async(dataEM) => { setEM(await dataEM.json());})
        .catch(e => {console.log(e);})
        var interval1=setInterval(function () {
            number++;
            if(code == sessionStorage.getItem("key")) { // No ha cambiado de página
                fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/energyMeter?idSolarFarm="+idParque+"&variables="+variablesAPedir, { method: 'GET', credentials: 'include' })
                .then( async(dataEM) => { setEM(await dataEM.json());})
                .catch(e => {console.log(e);})
            } else { // Ha cambiado de página. Cancela bucle
                clearInterval(interval1);
            }    
        }, 30000)
    }, [number]);

    useEffect(()=>{
        htmlEM = EM.map((datoEM, index) => {
            const { description, timeStamp, p, s, pF, q, wp_dmd, wp_sup, wq_ind, wq_cap, ws, iL1, iL2, iL3, uL1L2, uL2L3, uL3L1, pL1, pL2, pL3, qA, qB, qC, sA, sB, sC, pFa, pFb, pFc, 
                    thdsVaVab, thdsVbVbc, thdsVcVca, thdsIa, thdsIb, thdsIc, f } = datoEM;
            return(
            <div className='col-12 col-sm-6'>
                <h3>{description}</h3>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Fecha lectura</th>
                            <th>{timeStamp}</th>
                        </tr>
                    </thead>

                    <tbody>
                        {p ? <tr>
                            <td>Potencia Activa</td>
                            <td><strong>{p}</strong></td>
                        </tr> : <></>}

                        {q ? <tr>
                            <td>Potencia Reactiva</td>
                            <td><strong>{q}</strong></td>
                        </tr>:<></>}

                        {s ? <tr>
                            <td>Potencia Aparente</td>
                            <td><strong>{s} </strong></td>
                        </tr>: <></>}

                        {pF ? <tr>
                            <td>Factor de Potencia</td>
                            <td><strong>{pF}</strong></td>
                        </tr> : <></>}

                        {f ? <tr>
                            <td>Frecuencia</td>
                            <td><strong>{f}</strong></td>
                        </tr>: <></>}

                        {wp_dmd ?<tr>
                            <td>Demanda energía activa</td>
                            <td><strong>{wp_dmd}</strong></td>
                        </tr>: <></>}

                        {wp_sup ? <tr>
                            <td>Suministro energía activa</td>
                            <td><strong>{wp_sup}</strong></td>
                        </tr> : <></>}

                        {wq_ind ? <tr>
                            <td>Energía reactiva inductiva</td>
                            <td><strong>{wq_ind}</strong></td>
                        </tr>: <></>}

                        {wq_cap ? <tr>
                            <td>Energía reactiva capacitiva</td>
                            <td><strong>{wq_cap}</strong></td>
                        </tr>: <></>}

                        {ws ? <tr>
                            <td>Energía aparente</td>
                            <td><strong>{ws}</strong></td>
                        </tr> : <></>}

                        {iL1 ? <tr>
                            <td>Intensidad A</td>
                            <td><strong>{iL1}</strong></td>
                        </tr> : <></>}

                        {iL2 ? <tr>
                            <td>Intensidad B</td>
                            <td><strong>{iL2}</strong></td>
                        </tr>: <></>}

                        {iL3 ? <tr>
                            <td>Intensidad C</td>
                            <td><strong>{iL3}</strong></td>
                        </tr> : <></>}

                        {uL1L2 ? <tr>
                            <td>Tensión A-B</td>
                            <td><strong>{uL1L2}</strong></td>
                        </tr> : <></>}

                        {uL2L3 ? <tr>
                            <td>Tensión B-C</td>
                            <td><strong>{uL2L3}</strong></td>
                        </tr> : <></>}

                        {uL3L1 ? <tr>
                            <td>Tensión C-A</td>
                            <td><strong>{uL3L1}</strong></td>
                        </tr>: <></>}

                        {pL1 ? <tr>
                            <td>Potencia Activa A</td>
                            <td><strong>{pL1}</strong></td>
                        </tr>:<></>}

                        {pL2 ? <tr>
                            <td>Potencia Activa B</td>
                            <td><strong>{pL2}</strong></td>
                        </tr>: <></>}

                        {pL3 ? <tr>
                            <td>Potencia Activa C</td>
                            <td><strong>{pL3}</strong></td>
                        </tr>:<></>}

                        {qA ? <tr>
                            <td>Potencia Reactiva A</td>
                            <td><strong>{qA}</strong></td>
                        </tr>:<></>}

                        {qB ? <tr>
                            <td>Potencia Reactiva B</td>
                            <td><strong>{qB}</strong></td>
                        </tr>:<></>}

                        {qC ? <tr>
                            <td>Potencia Reactiva C</td>
                            <td><strong>{qC}</strong></td>
                        </tr>:<></>}

                        {sA ? <tr>
                            <td>Potencia Aparente A</td>
                            <td><strong>{sA}</strong></td>
                        </tr>:<></>}

                        {sB ? <tr>
                            <td>Potencia Aparente B</td>
                            <td><strong>{sB}</strong></td>
                        </tr>:<></>}

                        {sC ? <tr>
                            <td>Potencia Aparente C</td>
                            <td><strong>{sC}</strong></td>
                        </tr>:<></>}

                        {pFa ? <tr>
                            <td>Factor de Potencia A</td>
                            <td><strong>{pFa}</strong></td>
                        </tr>:<></>}

                        {pFb ? <tr>
                            <td>Factor de Potencia B</td>
                            <td><strong>{pFb}</strong></td>
                        </tr>:<></>}

                        {pFc ? <tr>
                            <td>Factor de Potencia C</td>
                            <td><strong>{pFc}</strong></td>
                        </tr>:<></>}

                        {thdsVaVab ? <tr>
                            <td>THDS (Va/Vab)</td>
                            <td><strong>{thdsVaVab}</strong></td>
                        </tr>:<></>}

                        {thdsVbVbc ? <tr>
                            <td>THDS (Vb/Vbc)</td>
                            <td><strong>{thdsVbVbc}</strong></td>
                        </tr>:<></>}

                        {thdsVcVca ? <tr>
                            <td>THDS (Vc/Vca)</td>
                            <td><strong>{thdsVcVca}</strong></td>
                        </tr>:<></>}

                        {thdsIa ? <tr>
                            <td>THDS (Ia)</td>
                            <td><strong>{thdsIa}</strong></td>
                        </tr>:<></>}

                        {thdsIb ? <tr>
                            <td>THDS (Ib)</td>
                            <td><strong>{thdsIb}</strong></td>
                        </tr>:<></>}

                        {thdsIc ? <tr>
                            <td>THDS (Ic)</td>
                            <td><strong>{thdsIc}</strong></td>
                        </tr>:<></>}
                    </tbody>
                </Table>
            </div>
        );
        });
        setHtmlEM(htmlEM);
    },[EM]);

    return(
        <div className='container-fluid div-janitza-tables'  style={{marginTop: '20px'}}>
            <div className='row'>
                {htmlEM}
            </div>
        </div>
    )
}

export default Analizador;